import React from "react";
import BushelPrice from "../../components/BushelPrice/BushelPrice";
import AllocationNumbers from "../../components/SalesAllocation";
import TagRange from "../../components/TagRange/TagRange";

function SalesForm3({
  currentStep,
  pricePerBushel,
  allocationNumbers,
  tagNumbers,
  handleInputChange,
  handlePricePerBushel,
  handleAllocationChange,
  handleTagChange,
  handleDeleteTag,
}) {
  if (currentStep !== 3) {
    return null;
  }
  return (
    <div>
      <BushelPrice
        bushelPrice={pricePerBushel}
        handleChange={handleInputChange}
        handleBlur={handlePricePerBushel}
      />
      <AllocationNumbers
        allocationNumbers={allocationNumbers}
        handleChange={handleAllocationChange}
      />
      <TagRange
        tagNumbers={tagNumbers}
        handleChange={handleTagChange}
        handleDelete={handleDeleteTag}
      />
    </div>
  );
}

export default SalesForm3;
